import { googleLogout } from '@react-oauth/google';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Routes } from "@cms/utils/routes";
import { useAppDispatch } from "@cms/utils/store/hooks";
import { signOutAsyncAction } from "@cms/utils/store/slices/user.slice";

const SignOutPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        googleLogout();
        localStorage.clear();
        dispatch(signOutAsyncAction())
        navigate(Routes.SIGN_IN)
    }, [])

    return (
        <div className='w-full min-h-screen flex flex-col justify-center items-center'>
            ...
        </div>
    )
}

export default SignOutPage